export default __webpack_public_path__ + "static/media/warning.afdcba3b.svg";